<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/7awkaL/tc-custom/9781429984942.jpg?1726444246380" alt="This image is the cover for the book There's Something About St. Tropez"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">There's Something About St. Tropez
      </h1>
      <p class="bookDescription body article font2">
        <b>Murder and mayhem await a celebrity P.I. and his girlfriend on the French Riviera in this romantic suspense mystery by a <i>New York Times</i>–bestselling author.</b><br/><br/>At a St. Tropez villa in the South of France, five international vacationers, strangers to one another—all of them misfits running from their daily lives—are brought together at the same small seaside Hotel of Dreams by a rental scam, an international art heist, passion, murder, and a haunting.<br/><br/>It had seemed like the perfect getaway for Private Investigator Mac Reilly and his girlfriend/partner, Sunny Alvarez, along with his three-legged, one-eyed rescue dog, Pirate, and her snippy three-pound fiend on four paws, the Chihuahua, Tesoro. But suddenly and rather unexpectedly, they find themselves having to sort out the misfits’ lives—including two lonely children on the trail of a mystery—solve a crime, and solve a murder, all against the sunny and glamorous backdrop of St. Tropez.<br/><br/>The two children are hot on the path to finding the killer. Will they get there first?<br/><br/>Elizabeth Adler transports us to the azure waters of the Mediterranean with a delicious caper filled with her trademark twists, sumptuous descriptions, and unforgettable characters.<br/><br/><b>Praise for <i>There’s Something About St. Tropez</i></b><br/><br/>“[A] sparkling sequel.” —<i>Publishers Weekly</i><br/><br/>“It all goes down as easily—and deliciously—as an ice-cold bottle of French rosé.” —<i>People </i>magazine<br/><br/>“Like her previous Mac Reilly mystery, <i>One of Those Malibu Nights . . .</i> Adler’s latest is filled with colorful characters and spicy skullduggery.” —<i>Booklist</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Elizabeth Adler
      </h2>
      
      <p class="authorDescription body article"><P>ELIZABETH ADLER is the internationally acclaimed author of twentyone novels. She lives in Palm Springs, California.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8809f6fe